module.exports = __webpack_public_path__ + "static/media/midframe.904be253.jpg";